export const temperatureConstants = {
  GET_TEMPERATURE_HISTORY_REQUEST: 'TEMPERATURE_GET_HISTORY_REQUEST',
  GET_TEMPERATURE_HISTORY_SUCCESS: 'TEMPERATURE_GET_HISTORY_SUCCESS',
  GET_TEMPERATURE_HISTORY_FAILURE: 'TEMPERATURE_GET_HISTORY_FAILURE',
  GET_TEMPERATURE_HISTORY_CANCEL:  'TEMPERATURE_GET_HISTORY_CANCEL',
};
